import {
    changeConditions,
    changeDataTypeSelection,
    changeDataTypeSelectionForSingleConditionTool,
    changeSelectedRefinementFilters,
    fixMissingLoadedRefinementFilters,
    initializeDataTypeSelection,
    initializeDefaultRefinementFilters,
    resetDataTool,
    setSamplePopulationSize,
    toggleIncludeNowcasts,
    validateYearRefinementFilters,
} from './actions';

// not in actions.ts: a non-action-creator export breaks RootAction's inference
export const filtersChangedSinceLastRequestActions = [
    resetDataTool,
    changeConditions,
    initializeDataTypeSelection,
    changeDataTypeSelection,
    changeDataTypeSelectionForSingleConditionTool,
    initializeDefaultRefinementFilters,
    fixMissingLoadedRefinementFilters,
    changeSelectedRefinementFilters,
    validateYearRefinementFilters,
    setSamplePopulationSize,
    toggleIncludeNowcasts,
];
